import IState from '@/interfaces/IState';
import getCookieDomain from '@/libs/domain/getCookieDomain';
import router from '@/router';
import Cookies from 'js-cookie';


export default (state: IState) => {
    state.access_token = null;
    state.profile = null;
    // Cookies.remove('access_token', { domain: getCookieDomain() });
    localStorage.removeItem('access_token');
    router.push('/sign-in');
};
